import React from 'react';
import type { CollectButtonSource } from '@soundxyz/utils/analytics';
import { Collect, ConnectWallet } from '@components/CollectButton/shared';
import { useAuth } from '@context/auth/base';
import { trackClickEvent } from '@lib/analytics';

export const CollectButton = ({
  onBuy,
  disabled,
  loading,
  releaseId,
  source,
}: {
  onBuy: () => void;
  disabled?: boolean;
  loading?: boolean;
  releaseId: string;
  source: CollectButtonSource;
}) => {
  const { isAuthenticatedWithAPI } = useAuth();

  return !!isAuthenticatedWithAPI ? (
    <Collect
      fullWidth
      variant="fuchsia"
      onClick={() => {
        trackClickEvent({
          event: 'Collect Now Clicked',
          properties: {
            associationId: releaseId,
            associationType: 'Release',
            sourceComponent: source,
          },
        });
        onBuy();
      }}
      disabled={disabled}
      loading={loading}
    />
  ) : (
    <ConnectWallet fullWidth sourceComponent={source} />
  );
};
